import { defineMessages } from 'react-intl-next';

export const rovoLoomScriptMessages = defineMessages({
	rovoLoomScriptPrompt: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-loom-script.prompt',
		defaultMessage:
			'Write a script for a concise walk-through video of this page. It should be no more than 90 seconds. Start with a friendly introduction, cover the key information of the page, and end with a call-to-action for any feedback.',
		description: 'Prompt text sent to LLM to request generation of a Loom recording script',
	},
	rovoLoomScriptChatTitle: {
		id: 'experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-loom-script.chat-title',
		defaultMessage: 'Loom Script for Confluence Page',
		description: 'Title displayed in the chat interface for the LLM-generated Loom script section',
	},
});
